var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-dialog-header"},[_c('div',{staticClass:"custom-header"},[_c('span',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"title-underline"}),_c('img',{staticClass:"close-btn",attrs:{"src":"https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"},on:{"click":_vm.handleClose}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }